import { render } from "./ShareLinkAdministration.vue?vue&type=template&id=33f5a396&scoped=true"
import script from "./ShareLinkAdministration.vue?vue&type=script&lang=ts"
export * from "./ShareLinkAdministration.vue?vue&type=script&lang=ts"

import "./ShareLinkAdministration.vue?vue&type=style&index=0&id=33f5a396&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-33f5a396"

export default script